import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const canEditRowSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    if (!bomItem) return false

    if (bomItem.type !== 'Row' && bomItem.type !== 'Assembly') {
      return true
    } else return bomItem.canBeEdit
  }
